import React from "react";
import { connect } from "react-redux";
import { getService, IService, updateService } from "../../../redux/modules/services";
import ServiceForm from "../../ServiceForm";
import { withRouter } from "../../../hooks/withRouter";
import { RootState } from "../../../redux";
import "./service-page.css";

interface ServicePageProps {
  services?: IService[];
  router?: { params?: { id?: string }; location?: { search?: string } };
  getService?: (serviceId: number) => void;
  updateService?: (service: IService) => void;
}

class ServicePage extends React.Component<ServicePageProps> {
  constructor(props: ServicePageProps) {
    super(props);
  }

  componentDidMount() {
    const id = this.props?.router?.params?.id;
    if (!id) {
      return;
    }
    this.props.getService && this.props.getService(+id);
  }

  renderServiceData() {
    const pageId = this.props?.router?.params?.id;
    if (!this.props.services || !pageId) {
      return;
    }
    const service = this.props.services.find(({ id }) => id === +pageId);
    if (!service) {
      return (
        <div className="service-page__empty">
          <p className="service-page__empty-text">Послугу з id: {pageId} не знайдено</p>
        </div>
      );
    }
    return (
      <>
        <div className="service-page__header">
          <div className="service-page__title-row">
            <h1 className="service-page__title">{service.archived ? "Послуга" : "Редагувати Послугу"}</h1>
            {service.archived && <span className="service-page__archived-badge">Архів</span>}
          </div>
          {!service.archived && <p className="service-page__subtitle">Оновіть інформацію про послугу</p>}
        </div>
        <div className="service-page__form-container">
          <ServiceForm service={service} saveHandler={service.archived ? undefined : this.props.updateService} readOnly={service.archived} />
        </div>
      </>
    );
  }

  render() {
    return (
      <div className="service-page">
        <div>{this.renderServices()}</div>
      </div>
    );
  }

  renderServices() {
    if (this.props.services && Object.keys(this.props.services).length) {
      return this.renderServiceData();
    }
    return (
      <div className="service-page__loading">
        <p className="service-page__loading-text">Завантаження послуги...</p>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return { services: Object.values(state.servicesState.services) };
};

export default withRouter(
  connect(mapStateToProps, {
    getService,
    updateService
  })(ServicePage)
);